import Konva from "konva";
import CustomText from "../CustomText";

export function renderCriteriaList(block, crystalizedData, options) {
  const { x = 0, y = 0, width = 300, height = 300, imageCallback, fontScale = 1 } = options;
  const s = fontScale;
  const group = new Konva.Group({ x, y, width, height });

  const items = block.items || [];
  if (items.length === 0) { group.height(height); return group; }

  const numCols   = Math.max(1, block.columns || 1);
  const pad       = Math.round(8 * s);
  const gap       = Math.round(8 * s);
  const colGap    = Math.round(12 * s);
  const badgeW    = Math.round(32 * s);
  const badgeGap  = Math.round(10 * s);
  const writeBoxW = Math.round(80 * s);
  const maxRowH   = Math.round(38 * s);

  // Optional guidance line rendered at the bottom of the score-box area.
  // Pre-create the node so we can measure its height and reserve space for it.
  let guidanceNode = null;
  let guidanceReserve = 0;
  if (block.guidance) {
    guidanceNode = new CustomText({
      x: pad, width: width - pad * 2,
      text: block.guidance,
      fontSize: Math.round(9 * s), fontStyle: "italic",
      fill: "#888", lineHeight: 1.25,
      refreshCallback: imageCallback
    });
    guidanceReserve = guidanceNode.height() + Math.round(6 * s);
  }

  const availH = height - pad * 2 - guidanceReserve;
  const rowsPerCol = Math.ceil(items.length / numCols);
  const totalGap = gap * (rowsPerCol - 1);
  const rowH = Math.min(maxRowH, Math.floor((availH - totalGap) / rowsPerCol));
  const colW = Math.floor((width - pad * 2 - colGap * (numCols - 1)) / numCols);

  items.forEach((item, idx) => {
    const forceRight = numCols > 1 && item.no_badge === true && idx === items.length - 1;
    const col = forceRight ? numCols - 1 : idx % numCols;
    const row = Math.floor(idx / numCols);
    const cx = pad + col * (colW + colGap);
    const cy = pad + row * (rowH + gap);

    const hasBadge = item.no_badge !== true;
    const badgeColor = item.badge_color || "#4CAF50";
    const badgeFontSize = Math.round((numCols > 1 ? 9 : 11) * s);
    const labelFontSize = Math.round((numCols > 1 ? 11 : 13) * s);

    if (hasBadge) {
      group.add(new Konva.Rect({
        x: cx, y: cy,
        width: badgeW, height: rowH,
        fill: badgeColor, cornerRadius: Math.round(4 * s)
      }));
      const badgeText = new CustomText({
        x: cx, width: badgeW,
        text: item.badge || "",
        fontSize: badgeFontSize, fontStyle: "bold",
        fill: "white", align: "center",
        refreshCallback: imageCallback
      });
      badgeText.y(cy + Math.round((rowH - badgeText.height()) / 2));
      group.add(badgeText);
    }

    const labelX = cx + (hasBadge ? badgeW + badgeGap : 0);
    const labelW = cx + colW - labelX - writeBoxW - badgeGap;
    const labelText = new CustomText({
      x: labelX, width: labelW,
      text: item.label || "",
      fontSize: labelFontSize,
      fill: "#1a1a1a",
      refreshCallback: imageCallback
    });
    labelText.y(cy + Math.round((rowH - labelText.height()) / 2));
    group.add(labelText);

    group.add(new Konva.Rect({
      x: cx + colW - writeBoxW, y: cy,
      width: writeBoxW, height: rowH,
      fill: "white",
      stroke: "#AAAAAA", strokeWidth: 1,
      cornerRadius: Math.round(3 * s)
    }));
  });

  if (guidanceNode) {
    guidanceNode.y(height - pad - guidanceNode.height());
    group.add(guidanceNode);
  }

  group.height(height);
  return group;
}
